import React from 'react';
import DownloadIcon from '@mui/icons-material/Download';
import { downloadFile } from '@cp/shared/lib/browser';
import { Button } from '@cp/ds/src/components/button';
import { Stack } from '@cp/ds/src/components/stack';
import { RotateIcon } from '@cp/ds/src/icons/rotate';
import { DeleteIcon } from '@cp/ds/src/icons/delete';
import { MOBILE_BREAKPOINT_THRESHOLD } from '@youhelp-ru/ui';
import { SVGIconTokens } from '../../../svgIcon';
import { useTheme } from '../../../../hooks';
import { ActionBarProps } from './model';

export const ActionBar: React.FC<ActionBarProps> = ({ imageUrl, orientation = 'vertical', sx, onDelete, onRotate, showDownloadButton }) => {
  const { breakpoints } = useTheme();
  return (
    <Stack
      direction={orientation === 'horizontal' ? 'row' : 'column'}
      spacing={2}
      sx={{
        ...sx,
        [breakpoints.down(MOBILE_BREAKPOINT_THRESHOLD)]: {
          [SVGIconTokens.Size]: '24px',

          button: {
            width: 36,
            height: 36,
          },
        },
      }}
    >
      <Button color="gray ultra light" onClick={onRotate} size="small" square variant="secondary">
        <RotateIcon />
      </Button>
      <Button color="gray ultra light" onClick={onDelete} size="small" square variant="secondary">
        <DeleteIcon />
      </Button>
      {showDownloadButton && imageUrl ? (
        <Button
          color="gray ultra light"
          onClick={() => {
            if (!imageUrl) {
              return;
            }

            let filename: string;
            if (imageUrl.startsWith('data:')) {
              const mimeMatch = imageUrl.match(/data\/([^;]+)/);
              const mimeType = mimeMatch ? mimeMatch[1] : 'png';
              const timestamp = Date.now();
              filename = `ai-image-${timestamp}.${mimeType}`;
            } else {
              filename = imageUrl.split('/').pop() ?? 'image';
            }

            downloadFile({ resource: imageUrl, filename });
          }}
          size="small"
          square
          variant="secondary"
        >
          <DownloadIcon />
        </Button>
      ) : null}
    </Stack>
  );
};
